module.exports = __webpack_public_path__ + "img/entrance.0b2518dc.jpg";